import { notifiFail } from 'components/Common/FloatingNotifications/notifi';
import { takeLatest, put, call } from 'redux-saga/effects';
import { fetchPaymentsAction } from 'redux/actions/paymentsActions';
import ACREAPI from 'utils/services/ACREAPI';

function* paymentsSaga(action) {
    try {
        yield put(fetchPaymentsAction.request());

        const response = yield call(ACREAPI.payments().index, action.payload);

        yield put(fetchPaymentsAction.success(response.data.result));
    } catch (e) {
        notifiFail({
            message: 'Loading of payments has been failed',
        });

        yield put(fetchPaymentsAction.failure());
    } finally {
        yield put(fetchPaymentsAction.fulfill());
    }
}

export default function* paymentsSagaWatcher() {
    yield takeLatest(fetchPaymentsAction.trigger, paymentsSaga);
}
